import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
export default {
  name: 'formPgae',
  data() {
    return {
      typeOption: [{
        key: 'clothes',
        label: '衣服'
      }, {
        key: 'shoes',
        label: '鞋子'
      }, {
        key: 'snacks',
        label: '零食'
      }, {
        key: 'sport',
        label: '运动器材'
      }, {
        key: 'fruits',
        label: '水果'
      }, {
        key: 'frequently',
        label: '日用品'
      }, {
        key: 'other',
        label: '其他'
      }],
      form: {
        name: '',
        type: '',
        weight: '',
        price: '',
        topping: false,
        text: '',
        date: [],
        reviewer: 'Siri'
      }
    };
  },
  computed: {
    formRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('商品名称不能为空') + '！'
        }],
        type: [{
          required: true,
          trigger: 'blur',
          message: this.$t('商品类型不能为空!') + '！'
        }],
        weight: [{
          required: true,
          trigger: 'blur',
          message: this.$t('商品重量不能为空')
        }],
        date: [{
          required: true,
          trigger: 'blur',
          message: this.$t('时间不能为空')
        }]
      };
    }
  },
  methods: {
    changeType(val) {
      this.form.type = val;
    },
    changTime(val, str) {
      this.form.date = str;
    },
    addFormData() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$message.success(this.$t('模拟添加成功'));
        }
      });
    },
    resetFrom() {
      this.$refs.form.resetFields();
    }
  }
};